<template>
  <div class="v-summary">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4" lg="3" xl="2">
          <ProjectsList :simple="true" multiple />
        </v-col>
        <v-col cols="12" md="8" lg="9" xl="10" v-if="selectedProject">
          <SummaryByProject :projectId="selectedProject" :key="selectedProject.toString()"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'Summary',
  components: {
    ProjectsList: () => import('@/components/tasks_editor/ProjectsList.vue'),
    SummaryByProject: () => import('@/components/summary/SummaryByProject.vue')
  },
  data () {
    return {
    }
  },
  computed: {
    selectedProject () {
      return this.$store.getters.getSelectedProject
    }
  }
}
</script>
